import { render } from "./notificationsList.vue?vue&type=template&id=783b74e6"
import script from "./notificationsList.vue?vue&type=script&lang=js"
export * from "./notificationsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__